import { render, staticRenderFns } from "./ServiceImage.vue?vue&type=template&id=06e7f11d"
import script from "./ServiceImage.vue?vue&type=script&lang=js"
export * from "./ServiceImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports